<template>
    <div class="l-app-main-section-container two">
        <div class="ui relaxed padded grid">
            <div class="middle aligned row">
                <div class="six wide column">
                    <h2 class="text-green text-medium">{{keyword}}</h2>
                    <h5 class="text-lightgrey">Alternative Words:  {{alternative_words}}</h5>
                    <h6 class="text-lightgrey">Updated: {{updateDate}}  </h6>
                    
                </div>
                
                <div class="ten wide right aligned column">
                    <button class="ui small button" @click="editKeyword()">Edit keyword List</button>
                </div>
            </div>
            <div class="row">
                <div class="column">
                    <div class="padding-top-md"></div>
                    <div class="ui equal width middle aligned grid">
                        <div class="column">
                            <h3 class="text-medium">  {{total}} Record</h3>
                        </div>
                        <div class="right aligned column">
                            <div class="ui search link small input">
                                <input type="text" placeholder="Search Phone Number" v-on:keyup="setListValue(selectedList, false)" v-model="mobile" />
                            </div>
                        </div>
                    </div>
                    <table class="ui styled celled top attached table">
                        <thead>
                            <tr>
                                <th>Phone Number</th>
                                <th>Message</th>
                                <th class="center aligned" colspan="2"><i class="fas fa-ellipsis-h"></i></th>
   
                            </tr>
                        </thead>
                        <tbody>
                            
                            <tr v-for="list in listData" :key="list.inbox_id">
                                <td>{{list.msisdn}}</td>
                                <td>{{list.message}}</td>
                                <td class="center aligned collapsing">
                                    <button class="ui icon primary mini button" @click="sendMessageInbox(list)">Reply</button>
                                    <button class="ui icon green mini button" @click="addComments(list)">Add Comment</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-show="!loading" @click="setListValue(selectedList, false)" class="ui fluid small bottom attached button">Load More</div>
                </div>
            </div>
        </div>
        <loader v-show="loading"></loader>
        <inboxReplymessage />
        <EditKeywordList />
        <inboxComments />
    </div>

</template>

<script>
    import EditKeywordList from "@/modals/editInboxKeyword";
    import inboxReplymessage from '@/modals/inbox-reply-message';
    import inboxComments from '@/modals/inbox-comment';
    import loader from "@/components/loader";
    import store from "@/store";
    import bulkstore from "@/bulk/bulksms-state";
    import alertify from 'alertifyjs';
    import Dropzone from "dropzone";
    import moment from "moment";
    
    
    
    export default {
        components: {
            loader,
            inboxReplymessage,
            EditKeywordList,
            inboxComments
        },
        data() {
            return {
                listData: [],
                keyword:"",
                total:0,
                client_id:"",
                short_code:"",
                mobile:"",
                alternative_words:"",
                loading:false,
                totalKeywords:0,
                updateDate:"",
                selectedList:[]

            }
        },
        
        mounted() {
    
            let vm = this;
            if (vm.$route.params.id != "" && !isNaN(vm.$route.params.id)) {
                var listid = vm.$route.params.id;
            }
            vm.selectedList = bulkstore.state.selectKeywordInbox;
            
        },
        methods: {
            setListValue(selectedList, is_loadmore) {
                var vm = this;
                 if (!is_loadmore) {
                    
                    if (selectedList.keyword_id != vm.listData.keyword_id) {
                        
                        vm.totalKeywords = 0;
                        vm.listData = [];
                        vm.offset = 0;
                    } else {
                       
                        vm.totalKeywords = 0;
                        vm.listData = [];
                        vm.offset = 0;
                    }

    
                }
                
                if (vm.$route.params.id != "" && !isNaN(vm.$route.params.id)) {
                    vm.keyword = vm.listData[0].keyword; 
                    vm.total = vm.listData[0].message_count; 
                    vm.client_id = vm.listData[0].client_id; 
                    vm.short_code = vm.listData[0].short_code; 
                    vm.alternative_words = vm.listData[0].alternative_words; 
                    vm.updateDate = vm.listData[0].created_at;
                }
                else{
                    vm.keyword = bulkstore.state.selectKeywordInbox.keyword;
                    vm.total = bulkstore.state.selectKeywordInbox.message_count;
                    vm.client_id = bulkstore.state.selectKeywordInbox.client_id;
                    vm.short_code = bulkstore.state.selectKeywordInbox.short_code;
                    vm.alternative_words = bulkstore.state.selectKeywordInbox.alternative_words; 
                    vm.updateDate = bulkstore.state.selectKeywordInbox.created_at;
                }

    
                if (vm.totalKeywords === 0 || vm.totalKeywords >= ((vm.offset - 1) * vm.limit)) {
                    vm.offset++;
                    vm.loading = true;
                    $.post({
                        url: store.state.rootUrl + 'notify/keyword/view',
                        type: "POST",
                        data: JSON.stringify({
                            apiKey: this.$cookies.get("key"),
                            alternative_words: vm.alternative_words,
                            short_code: vm.short_code,
                            client_id: vm.client_id,
                            msisdn: vm.mobile
                        }),
                        success: function(data, status, jQxhr) {
                            vm.loading = false;
                            var code = data.data.code;
    
                            if (code == 404) {
    
                            } else {
                                for (var i = 0; i < data.data.data.length; i++) {
                                    vm.listData.push(data.data.data[i])
                                }
                                vm.totalKeywords = data.data.data[0].total;
                            }
                        },
                        error: function(jQxhr, status, error) {
    
                            vm.loading = false;
                            // vm.contactList=[];
                            //vm.totalContacts=0;
                            var error = jQxhr.responseJSON.statusDescription;
                            if (error) {
                                alertify.error(error);
                            } else {
                                alertify.error("An error occurred ");
                            }
    
    
                        }
                    });
    
                }
    
    
    
            },
            sendMessageInbox(clientDetails) {
                let vm = this;
                store.commit("setInboxDetails", clientDetails);
                $('.ui.modal#modal-inbox-new-message').modal({
                    centered: false,
                    closable: true
                }).modal("show");
            },
            addComments(list){
                let vm = this;
                //console.log("am here");
                store.commit("setInboxDetails",list);
                $('.ui.modal#modal-inbox-comments').modal({
                    centered: false,
                    closable: true
                }).modal("show");
            },
            editKeyword() {
                $(".ui.modal#modal-edit-keyword-inbox").modal({
                    centered: false,
                    closable: true
                }).modal("show");
            },

        }
    }
</script>
